module.exports = __webpack_public_path__ + "1cd02f396ab7b849880fa999f9390924.png";